<template>
  <v-container fluid v-if="loggedIn">
    <v-row>
      <v-col cols="12" sm="6" lg="4" xl="3" v-for="tile in tiles" :key="tile.id">
        <v-alert class="d-flex flex-column align-stretch" dense outlined tile>
          <div class="grey--text headline name">{{ tile.name }}</div>
          <div :class="'d-flex justify-space-between align-end ' + tile.valuesClass">
            <div :class="tile.mainClass">{{ tile.mainValue }}</div>
            <div :class="tile.auxClass">{{ tile.auxValue }}</div>
          </div>
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="dashboard">
      <v-col cols="6" lg="3" xl="2">
        <v-alert dense outlined tile>
          <div>Prejete škode do 7 dni</div>
          <div class="display-2">{{ dashboard.skode_prejete_do_7_dni }}</div>
        </v-alert>
      </v-col>
      <v-col cols="6" lg="3" xl="2">
        <v-alert dense tile outlined color="blue darken-2">
          <div>Prejete škode do 14 dni</div>
          <div class="display-2">{{ dashboard.skode_prejete_do_14_dni }}</div>
        </v-alert>
      </v-col>
      <v-col cols="6" lg="3" xl="2">
        <v-alert dense outlined tile type="warning">
          <div>Prejete škode do 21 dni</div>
          <div class="display-2">{{ dashboard.skode_prejete_do_21_dni }}</div>
        </v-alert>
      </v-col>
      <v-col cols="6" lg="3" xl="2">
        <v-alert dense outlined tile type="error">
          <div>Prejete škode nad 21 dni</div>
          <div class="display-2">{{ dashboard.skode_prejete_nad_21_dni }}</div>
        </v-alert>
      </v-col>
    </v-row>

    <v-row fluid>
      <v-col cols="12" lg="6" class="h-chart">
        Sklenjene pogodbe po mesecih v zadnjih treh letih
        <line-chart :chartdata="chartData" :options="chartOptions" />
      </v-col>
    </v-row>
  </v-container>
  <article v-else>
    <div class="transparent-back">
      <img src="/img/logo.png" alt="GSV logo" />
      <p class="mt-8">Brez nas gre, a z nami je lažje.</p>
      <p class="mt-8">
        <a href="/login" class="white--text">Prijava</a>
      </p>
    </div>
  </article>
</template>

<script>
import LineChart from "@/components/LineChart";
import { mapGetters } from "vuex";

export default {
  components: { LineChart },
  data: () => ({
    dashboard: null,
    gProdajaPoMesecih: [],
    skodeDate: "",
    todayDay: "",
    yesterdayDay: "",
    skodeDanes: 0,
    skodeVceraj: 0,
    pogodbeDanes: 0,
    pogodbeVceraj: 0,
    chartOptions: {
      animation: {
        duration: 0,
      },
      spanGaps: false,
      responsive: true,
      maintainAspectRatio: false,
    },
  }),
  async created() {
    // console.log("home created");

    var today = new Date();
    if (today.getDay() === 0) {
      // preskoci nedeljo
      today.setDate(today.getDate() - 1);
    }

    var yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    if (yesterday.getDay() === 0) {
      // preskoci nedeljo
      yesterday.setDate(yesterday.getDate() - 1);
    }

    let todayParam = today.toISOString().substring(0, 10);
    let yesterdayParam = yesterday.toISOString().substring(0, 10);

    const options = {
      weekday: "long",
    };

    this.todayDay = today.toLocaleString("sl-SI", options).split(",")[0];
    this.yesterdayDay = yesterday.toLocaleString("sl-SI", options).split(" ")[0];

    await this.$axios.get(`/g_prodaja_po_mesecih`).then((response) => (this.gProdajaPoMesecih = eval(response.data)));
    await this.$axios
      .get(`/skode/${todayParam}/count`)
      .then((response) => (this.skodeDanes = eval(response.data[0].count)));
    await this.$axios
      .get(`/skode/${yesterdayParam}/count`)
      .then((response) => (this.skodeVceraj = eval(response.data[0].count)));
    await this.$axios
      .get(`/pogodbe/${todayParam}/count`)
      .then((response) => (this.pogodbeDanes = eval(response.data[0].count)));
    await this.$axios
      .get(`/pogodbe/${yesterdayParam}/count`)
      .then((response) => (this.pogodbeVceraj = eval(response.data[0].count)));
    await this.$axios.get(`/dashboard`).then((response) => (this.dashboard = eval(response.data)));
  },
  computed: {
    ...mapGetters(["user", "loggedIn"]),
    chartData(e) {
      return {
        labels: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
        datasets: [
          {
            label: "2023",
            data: this.gProdajaPoMesecih.map((e) => (e.count_2023 > 0 ? e.count_2023 : null)),
            // if null, potem ni prodaje ta mesec in ne bo šla dol črta, ampka sploh ne bo grafa
            borderWidth: 3,
            borderColor: "red", // The main line color
          },
          {
            label: "2022",
            data: this.gProdajaPoMesecih.map((e) => (e.count_2022 > 0 ? e.count_2022 : null)),
            // if null, potem ni prodaje ta mesec in ne bo šla dol črta, ampka sploh ne bo grafa
            borderWidth: 3,
            borderColor: "green", // The main line color
          },
          {
            label: "2021",
            data: this.gProdajaPoMesecih.map((e) => (e.count_2021 > 0 ? e.count_2021 : null)),
            // if null, potem ni prodaje ta mesec in ne bo šla dol črta, ampka sploh ne bo grafa
            borderWidth: 3,
            borderColor: "blue", // The main line color
          },

          {
            label: "2020",
            data: this.gProdajaPoMesecih.map((e) => (e.count_2020 > 0 ? e.count_2020 : null)),
            // if null, potem ni prodaje ta mesec in ne bo šla dol črta, ampka sploh ne bo grafa
            borderWidth: 1,
            borderColor: "violet", // The main line color
          },
          {
            label: "2019",
            // data: this.gProdajaPoMesecih,
            data: this.gProdajaPoMesecih.map((e) => (e.count_2019 > 0 ? e.count_2019 : null)),
            borderWidth: 1,
            borderColor: "orange", // The main line color
          },
          // {
          //   label: "2018",
          //   // data: this.gProdajaPoMesecih,
          //   data: this.gProdajaPoMesecih.map((e) =>
          //     e.count_2018 > 0 ? e.count_2018 : null
          //   ),
          //   borderWidth: 1,
          //   borderColor: "blue", // The main line color
          // },
        ],
      };
    },
    razlikaSkod() {
      const delta = this.skodeDanes - this.skodeVceraj;
      return delta > 0 ? "+" + delta : delta;
    },

    razlikaPogodb() {
      const delta = this.pogodbeDanes - this.pogodbeVceraj;
      return delta > 0 ? "+" + delta : delta;
    },
    pogodbeTaMesecNaDan() {
      return 343;
    },
    pogodbePrejsnjiMesecNaDan() {
      return 312;
    },
    tiles() {
      return [
        {
          id: 1,
          name: `Škode ${this.todayDay} / Δ ${this.yesterdayDay}`,
          mainValue: this.skodeDanes,
          mainClass: "display-2",
          auxValue: this.razlikaSkod,
          auxClass: "display-1 " + (this.skodeDanes > this.skodeVceraj ? " red--text " : " green--text"),
          valuesClass: "",
        },
        {
          id: 2,
          name: `Pogodbe ${this.todayDay} / Δ ${this.yesterdayDay}`,
          mainValue: this.pogodbeDanes,
          mainClass: "display-2",
          auxValue: this.razlikaPogodb,
          auxClass: "display-1 " + (this.pogodbeDanes > this.pogodbeVceraj ? " green--text " : " red--text"),
          valuesClass: "",
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.dash-card {
  width: 50%;
}

.headline.name {
  font-size: 1.2rem !important;
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .headline.name {
    font-size: 1.3rem !important;
  }
}

.h-chart {
  height: 250px;
}
@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .h-chart {
    height: 350px;
  }
}

article {
  width: 100vw;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  align-content: center;
  justify-items: center;

  background-image: url("/img/home-back.jpg");
}

.transparent-back {
  font-family: "Georgia";
  background-color: rgba(240, 240, 240, 0.1);
  border: grey 1px solid;
  color: white;
  padding: 50px;
  border-radius: 1rem;
  font-size: 2rem;
  font-weight: 700;
}
</style>
